import { ActionContext } from 'vuex'

const state = {
  isActive: false,
}

type State = typeof state
type ModuleActionContext = ActionContext<State, {}>

const getters = {}

const actions = {
  show: function ({ commit }: ModuleActionContext) {
    commit('setIsActive', true)
  },
  onEntered: function ({ commit }: ModuleActionContext) {
    commit('setIsActive', false)
  },
}

const mutations = {
  setIsActive(state: State, value: boolean) {
    state.isActive = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
